/**
 * Holds the different types of variants that can be generated for an asset.
 * @see {@link VariantType} for more information.
 */
export const variants = [
    "original",
    "print",
    "webPreview",
    "thumb",
    "backgroundRemoved",
    "sharpened",
    "embroidery",
    "monochrome",
    "embroiderify",
    "invertColor",
    "sepia",
    "greyscale",
    "segmentize",
    "cropped",
    "colorReduce",
    "extractedLogos",
    "vectorExtractedLogos",
    "font",
    "documentItem",
    "classifications",
    "storage",
    "asset",
    "colors",
    "text",
    "quality",
    "vector",
];
/**
 * Checks if the variant is an info variant.
 * @param variant - The variant to check.
 * @returns True if the variant is an info variant, false otherwise.
 */
export const isInfoVariant = (variant) => {
    return ["font", "documentItem", "storage", "asset"].includes(variant);
};
/**
 * Checks if the variant is an info image variant.
 * @param variant - The variant to check.
 * @returns True if the variant is an info image variant, false otherwise.
 */
export const isInfoImageVariant = (variant) => {
    return ["classifications", "colors", "text", "quality"].includes(variant);
};
